<script setup lang="ts">
defineOptions({ name: "WCloseTag" })

withDefaults(defineProps<{ tip: string; type?: "success" | "warning" | "danger" }>(), {
  tip: "内容",
  type: "success"
})
const emit = defineEmits(["close"])

const visible = defineModel<boolean>("visible", { required: true, default: true })

const handleCloseTag = () => {
  visible.value = false
  emit("close")
}
</script>

<template>
  <div class="w-close-tag" v-if="visible">
    <el-tag
      :type
      closable
      style="font-size: 13px; padding: 15px 16px; width: 100%; justify-content: space-between"
      @close="handleCloseTag"
    >
      {{ tip }}
    </el-tag>
  </div>
</template>

<style scoped lang="scss">
.w-close-tag {
  box-shadow: $base-box-shadow;
  margin-bottom: 10px;
  background-color: unset;
}
</style>
